<div
  class="form-field"
  [class.show-error]="additionalErrorDisplayCondition !== undefined ? additionalErrorDisplayCondition : true">
  <label class="form-field-label">{{ label | translate }}</label>
  <mat-form-field appearance="outline">
    @if (showAutocompleteButton) {
      <input
        #autocompleteTrigger="matAutocompleteTrigger"
        type="text"
        matInput
        [placeholder]="formControlPlacehoder | translate"
        [formControl]="control"
        [matAutocomplete]="auto"
        [matAutocompleteDisabled]="!auto"
        (input)="!showAutocompleteButton && onAutocompleteSearchChange($event.target.value)"
        [id]="inputId" />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="onAutocompleteValueChange($event.option.value)"
        class="mytc-autocomplete-panel">
        @for (option of autocompleteValues; track option) {
          <mat-option [value]="option.value">
            {{ option.label }}
          </mat-option>
        }
      </mat-autocomplete>
    } @else {
      <input
        type="text"
        matInput
        [placeholder]="formControlPlacehoder | translate"
        [formControl]="control"
        [matAutocomplete]="auto"
        [matAutocompleteDisabled]="!auto"
        (ngModelChange)="!showAutocompleteButton && updatedAutocomplete($event)"
        [id]="inputId" />
      <mat-autocomplete
        #auto="matAutocomplete"
        [hideSingleSelectionIndicator]="true"
        (optionSelected)="onAutocompleteValueChange($event.option.value)"
        class="mytc-autocomplete-panel">
        @if (showAutocomplete) {
          @for (value of filteredValuesForAutocomplete$ | async; track value) {
            <mat-option [value]="value.value" [ngClass]="{ 'hide-autocomplete': !showAutocomplete }">
              {{ value.label }}
            </mat-option>
          }
        }
      </mat-autocomplete>
    }
    @if (showAutocompleteButton) {
      <button matSuffix class="autocomplete-button" (click)="onAutocompleteSearchChange($event)" type="button">
        <mat-icon svgIcon="autocomplete_search"></mat-icon>
      </button>
    }
  </mat-form-field>

  @if (
    control.errors &&
    (additionalErrorDisplayCondition !== undefined ? additionalErrorDisplayCondition : true) &&
    showDefaultErrors
  ) {
    @for (error of control | formatControlErrors; track error) {
      <div>
        @if (control.touched) {
          <mat-error class="base-error-message">
            {{ error }}
          </mat-error>
        }
      </div>
    }
  }
</div>
